<template>
  <svg
    viewBox="0 0 74 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="w-full h-full fill-current stroke-1"
  >
    <path
      d="M73 11.5469L54.5 22.2275V14.0469H0.5V9.04688H54.5V0.865234L73 11.5469Z"
      vector-effect="non-scaling-stroke"
    />
  </svg>
</template>
